import withAPI from './withAPI';
import ZoneSetup from './ZoneSetup';

export default withAPI(ZoneSetup);

export { ZoneSetup };
